(function($){


	$(document).ready(function () {

	});
		

});
        
   